"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooterStyled = void 0;

var _utils = require("../../../utils");

var _const = require("../../../const");

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modalSize = function modalSize(measure) {
  switch (measure) {
    case 'lg':
      return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: block;\n        max-width: 500px;\n        margin: 0 auto;\n      "])));
  }

  return false;
};

var ModalFooterStyled = (0, _utils.styled)('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 10px 10px 50px;\n  width: 100%;\n  ", ";\n\n  ", " {\n    padding-bottom: 10px;\n  }\n  ", "\n  ", "\n"])), function (_ref) {
  var measure = _ref.measure;
  return modalSize(measure);
}, _const.GridBreakpointsMediaDown.lg, function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return (0, _const.fullWidthHelperStyle)(fullWidth);
});
exports.ModalFooterStyled = ModalFooterStyled;